import script from "./AuthForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthForm.vue?vue&type=script&lang=ts&setup=true"

import "./AuthForm.vue?vue&type=style&index=0&id=73df4a28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73df4a28"]])

export default __exports__